import React, { Component } from 'react';
import { Field, reduxForm, formValueSelector, getFormValues, FormSection, SubmissionError, change, reset } from 'redux-form';
import { connect } from 'react-redux';
import { Link } from "react-router-dom";
import ReactLoading from 'react-loading';
import Modal from 'react-responsive-modal';
import ArtistLoginForm from '../components/ArtistLoginForm'

import agent from '../agent'

// import validate from './registration/validate';
import renderDatePicker from './Datepicker';
import Countries from '../data/countries';
import CountryStates from '../data/states';
import GenderOptions from '../data/gender';

import _range from 'lodash/range'
import _debounce from 'lodash/debounce'

import { history } from '../store/configureStore'
import SelectComponent from './ui/SelectComponent'
// import Select from 'react-select'

import AMLogo from '../assets/images/audition-magic-favicon.png';

// import ReactJson from 'react-json-view'
import RadioGroupComponent from './ui/RadioGroupComponent'

const renderField = ({ input, className, label, type, meta: { asyncValidating, touched, error, warning } }) => {
  if (touched && error) {
    return (
      <div className={className}>
      <div className="input-field">
        <label className="is-invalid-label">
          <input 
            {...input} 
            type={type}
            className="is-invalid-input" 
            placeholder={label} />
          <span className="form-error is-visible" id="uuid">{error}</span>
          { asyncValidating && <i className="fa fa-spinner fa-spin"></i> }
        </label>
      </div>
      </div>
    )
  }
  return (
    <div className={className}>
    <div className="input-field">
      <label>
        <input {...input} placeholder={label} type={type} />
        { asyncValidating && <i className="fa fa-spinner fa-spin"></i> }
      </label>
    </div>
    </div>
  )
}

const ShowArtistSelection = props => {
  return props.artists.map(artist => 
    <div className="column text-center artist-list" key={artist.id}>
      <div className="content">
      <div className="find-artist-image">
        <img src={artist.photo_thumb || AMLogo} alt=""/>
      </div>
      <div className="find-artist-name">{`${artist.first_name} ${artist.last_name}`}</div>
      <div className="find-artist-type">{artist.artist_type}</div>
      <div className="find-artist-location">{props.mapCountry(artist.country)}</div>
      <div className="find-artist-button" onClick={() => props.setThisIsMeArtist(artist, props.location)}>I am this artist</div>
      </div>
    </div>
  )
}

const validate = {
  required: value => !value && "This field is required",
  radioval: value => !value && console.log("union: " + value),
  password: value => value.length >= 15 && "The field Password must be a string with a maximum length of 15.",
  email: value => !/^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$$/.test(value) && "You have invalid email address"
} //"This field is required",

class ProfileForm extends Component {

  state = {
    errorMessage: false,
    selectedCountry: 'US',
    selectedAge_from: 0,
    countries: this.getCountries(),
    states: '',
    ages: this.getAges(),
    ageFrom: 0,
    ageTo: 0,
    ageFromOptions: this.generateRange(18, 101),
    ageToOptions: this.generateRange(19, 101),
    hasUnion: 'non-union',
    loading: false,
    showModal: false,
    isCheckingArtist: false,
    thisIsMeArtist: null,
    project: null
  }

  componentWillMount() {
    const { hasCountry, ageFromD } = this.props
    const projectId = new URLSearchParams(this.props.location.search).get('project');
    console.log('componentWillMount-profileform', hasCountry, ageFromD)
    this.setState({
      selectedCountry: hasCountry,
      selectedAge_from: ageFromD,
      ageFrom: 18,
      ageTo: 100,
      states: this.filterStateByCountry(hasCountry),
      hasUnion: 'non-union'
    })

    if (this.props.ageCategory == 'adult') {
      this.props.changeFieldValue("artist['age_from']", 18)
      this.props.changeFieldValue("artist['age_to']", 100)
    } else {
      this.props.changeFieldValue("artist['age_from']", 0)
      this.props.changeFieldValue("artist['age_to']", 17)
      this.setState({ageFrom: 0, ageTo: 17})
    }

    if (projectId != null) {
      this.props.changeFieldValue("artist['project_id']", projectId)
    }
  }

  async componentWillReceiveProps (nextProps) {
    const { artists } = nextProps
    const { publicArtist } = this.props
    if ( artists ) {
      if (artists.length) {
        this.setState({
          errorMessage: 'User is already exists'
        })  
      } else {
        this.setState({
          newArtist: true
        })
        console.log('componentWillReceiveProps > sumitting form')
      }
      this.setState({loading: false})
    }
    
    const projectId = new URLSearchParams(this.props.location.search).get('token');
    if (projectId != null) {
      this.props.changeFieldValue("artist['project_id']", projectId)
      let project = await agent.Project.viaToken(projectId)
      this.setState({project: project.project})
    }

    //console.log('receiveingProps' ,publicArtist)
  }

  submit = (values, dispatch, props) => {
    console.log('onSubmit_profile', values)
    this.setState({loading: true})
    const { first_name, last_name, email } = values.artist
    window.localStorage.setItem('artist_profile', JSON.stringify(values.artist));
    console.log(values.artist)

    if (this.state.newArtist) {
      return props.onSubmit(props.handleSubmit);
    }

    if (first_name && last_name) {
        props.searchArtist(values.artist)
    }
  }

  handleRadioChange(checkedvalue){
    console.log('radio-check: ' + checkedvalue);
  }

  getStates(value) {
    return this.filterStateByCountry(value)
    // return CountryStates.filter(states => states.countryCode === value || 'US')
  }

  getCountries() {
    return Countries.map(country => ({ value: country.code, label: country.name }) )
  }

  getAges() {
    return [{label: 'Adult', value: 'adult'}, {label: 'Child', value: 'child'}]
  }

  setThisIsMeArtist = (artist, location) => {
    // redirect to login

    console.log('>>>>', this.props, this.state)
    this.props.resetSearch()
    this.props.resetForm()
    this.setState({
      errorMessage: false,
      newArtist: false,
      showModal: true,
      thisIsMeArtist: artist
    })

    // history.push({
    //   pathname: '/artist/login',
    //   search: location.search,
    //   state: {
    //     ...location.state,
    //     thisIsMeArtist: artist
    //   }
    // })
  }

  newArtist = () => {
    console.log(this.state, this.props)
    const { dispatch } = this.props

    this.props.resetSearch()

    // this.props.reset()
    // this.resetBasicFields([
    //   'artist[first_name]', 
    //   'artist[last_name]', 
    //   'artist[email]'])

    this.setState({
      newArtist: true,
      errorMessage: false
    })
  }

  mapCountry(value) {
    return Countries.find(country => country.code == value).name || ""
  }
  
  resetBasicFields = (values) => {
    values.forEach(value => this.props.dispatch(change('artistRegistrationWizard', value, '')))
  }

  generateRange(start, end, step) {
      return _range(start, end, step).map(i => ({value: i, label: i}))
  }

  filterStateByCountry(country) {
    return CountryStates.filter(state => state.countryCode === (country || 'US') ) 
  }

  onChangeAgeFrom = (value, newValue) => {
    let upper_limit = (this.state.ageCategory === 'minor') ? 19 : 100

    this.setState({
      ageFrom: newValue,
      ageTo: newValue+1,
      ageToOptions: _range(parseInt(newValue) + 1, upper_limit).map(i => ({value: i, label: i}))
    })
  }

  onChangeAgeTo = (value, newValue) => {
    console.log('>To', newValue);
    this.setState({
      ageTo: newValue
    })
  }

  onChangeCountry = (value, countryCode ) => {
    console.log('onChangeCountry', value, countryCode)
    this.setState({
      states: this.filterStateByCountry(countryCode)
    })
  }

  onCloseModal = () => {
    this.setState({ showModal: false });
  }

  getInitialValues () {
    const username = this.state.thisIsMeArtist ? this.state.thisIsMeArtist.email : ""
    return {
      username: username
    }
  }

  login = values => {
    const { username, password } = values
    const projectId = new URLSearchParams(this.props.location.search).get('project');
    const publicRegistration = new URLSearchParams(this.props.location.search).get('token');
    
    if (username && password) {
      if (projectId) {
        return this.props.partialLogin(username, password)
      } else if (publicRegistration) {
        return this.props.publicLogin(username, password)
      } else {
        return this.props.artistLogin(username, password);    
      }
    }
  }

  render() {
    const { countries, countryStates, errorMessage } = this.state
    const { handleSubmit, artists, hasUnion, submitting, pristine, error, projectId, previousState, location, errors, ageCategory } = this.props
    const publicRegistration = new URLSearchParams(this.props.location.search).get('token');
    const type = { name: "spin" }
    var ageFromD = {}
    var ageToD = {}
    console.log('render-profileform', ageCategory)

    if (ageCategory === 'adult') {
      ageFromD = { value: 20, label: 20 }; ageToD = { value: 60, label: 60 };
      console.log('ageCategory-adult', this.props.ageCategory, ageFromD, ageToD)
    }

    if (this.props.publicArtist && this.props.location.state) {
      window.localStorage.setItem('artist_jwt', JSON.stringify(this.props.publicArtist));
      agent.setToken(this.props.publicArtist.meta)
      history.push({
        pathname: '/artist/dashboard',
        search: `?token=${publicRegistration}`,
        state: { 
          artist: this.props.publicArtist.artist, 
          publicArtist: this.props.publicArtist,
          clientDetails: {
            projectId: this.props.location.state.projectId,
            client: this.props.location.state.client
          }
        }
      })
    }
    return (
      <div>
        <Modal classNames={{ modal: 'tiny-modal sample-me' }} open={this.state.showModal} onClose={this.onCloseModal} little>
          <div id="login-modal">
            <div className="profile-form-modal">
              <h2>Profile Selected</h2>
              <p>Please enter your details below to proceed</p>
              <div className="form-wrapper">
                <ArtistLoginForm 
                  isCheckingArtist={this.state.isCheckingArtist}
                  onSubmit={this.login}
                  initialValues={this.getInitialValues()}
                  errors={error} />
              </div>
              <div className="clearfix"></div>
              <div className="row small-12 text-right padding-to-the-right">
                <button className="button" onClick={this.onCloseModal}>Close</button>
              </div>
            </div>
          </div>
        </Modal>
        <form onSubmit={ handleSubmit(this.submit) } className="registartion-profile-form" id="reg-profile-form">
          <section className="section gray-bg">
            <div className="grid-x align-center">
            <div className="small-12 medium-7 large-6 cell">
              
                { errorMessage && 
                  <div className="row show-artist-selection">
                    <div className="small-12 column">
                      <h5>Hi <span className="search-name">{this.props.artistValues.artist.first_name}</span>, we have found potential matches to your profile</h5>
                      <p>Great you are already a member! If this is you, click this is me artist. If this is not you, click I am none of these artist to create profile</p>
                    </div>
                    <div className="small-up-2 large-up-3 column">
                      <ShowArtistSelection
                        mapCountry={this.mapCountry} 
                        artists={artists} 
                        location={location}
                        setThisIsMeArtist={this.setThisIsMeArtist}/>
                    </div>
                    <div className="small-12 column text-center">
                      <div className="button not-my-artist" onClick={this.newArtist}>I AM NONE OF THESE ARTISTS</div>
                    </div>
                  </div>
                }

                {!errorMessage &&
                  <FormSection name="artist">
                    <div className="row">
                      <Field
                        className="small-12 medium-6 column"
                        name="first_name"
                        type="text"
                        validate={[validate.required]}
                        value={this.state.first_name}
                        component={renderField}
                        label="First Name" />
                      <Field
                        className="small-12 medium-6 column"
                        name="last_name"
                        type="text"
                        validate={[validate.required]}
                        component={renderField}
                        label="Last Name"/>
                    </div>

                    <div className="row">
                      <Field
                        className="small-12 column"
                        name="email"
                        type="email"
                        validate={[validate.email]}
                        component={renderField}
                        label="Email"/>
                    </div>

                    { this.state.newArtist &&
                      <div>
                          
                          <div className="row">
                            <div className="small-12 medium-6 column">
                              <small><strong>GENDER</strong></small><br/>
                              <Field
                                name="gender"
                                placeholder="Select gender"
                                component={SelectComponent}
                                options={GenderOptions} />

                            </div>
                            <small>&nbsp;</small><br/>
                            <Field
                              className="small-12 medium-6 column"
                                name="mobile_number"
                                type="text"
                                component={renderField}
                                validate={[validate.required]}
                                label="Mobile/Cell Number"/>
                           
                          </div>
                          

                          { this.props.ageCategory === 'adult' && this.state.project && !this.state.project.require_age_range &&
                            <div className="row">
                              <div className="small-12 medium-6 column">
                                <Field 
                                    name="age_from" 
                                    placeholder="Select age from"
                                    component="select"
                                    value={this.state.ageFrom}
                                    onChange={ this.onChangeAgeFrom }>
                                    {
                                      this.state.ageFromOptions.map((age, idx) => (
                                        <option key={idx + 1}
                                          value={age.value}>{age.label}</option>
                                      ))
                                    }
                                </Field>
                              </div>

                              <div className="small-12 medium-6 column">
                                <Field 
                                  name="age_to"
                                  placeholder="Select age to"
                                  value={this.state.ageTo}
                                  onChange={ this.onChangeAgeTo }
                                  component="select">
                                  {
                                    this.state.ageToOptions.map((age, idx) => (
                                      <option key={idx + 1}
                                        value={age.value}>{age.label}</option>
                                    ))
                                  }
                                </Field>
                              </div>

                            </div>
                          }

                          { this.props.ageCategory === 'adult' && this.state.project.require_age_range &&
                            <div style={{display: 'none'}}>
                              <Field 
                                  name="age_from" 
                                  placeholder="Select age from"
                                  component="select"
                                  value="18"
                                  type="hidden"/>
                              <Field 
                                  name="age_to" 
                                  placeholder="Select age from"
                                  component="select"
                                  value="100"
                                  type="hidden"/>
                            </div>
                          }

                          { this.props.ageCategory === 'child' && !this.state.project.require_age_range &&
                            <div className="row">
                              <Field
                                className="small-12 medium-12 column"
                                name="birth_date"
                                component={renderDatePicker} />
                            </div>
                          }
                          { this.props.ageCategory === 'child' && this.state.project.require_age_range &&
                            <div style={{display: 'none'}}>
                            <Field 
                                name="age_from" 
                                placeholder="Select age from"
                                component="select"
                                value="0"
                                type="hidden" />
                            <Field 
                                name="age_to" 
                                placeholder="Select age from"
                                component="select"
                                value="17"
                                type="hidden" />
                            </div>
                          }
                          { this.props.ageCategory == 'child' &&
                            <div className="row">
                              <Field
                                className="small-12 medium-6 column"
                                name="guardian_name"
                                type="text"
                                component={renderField}
                                label="Guardian Name"/>
                              
                              <Field
                                className="small-12 medium-6 column"
                                name="guardian_email"
                                type="text"
                                component={renderField}
                                label="Guardian Email Address"/>
                             
                            </div>

                          }

                          {
                            <div className="row">
                              <Field 
                                  name="ageCategory" 
                                  placeholder="Please select Age Category"
                                  validate={ [validate.required] }
                                  component={ SelectComponent } 
                                  onChange={ this.onChangeCountry }
                                  options={ this.state.ages } />
                            </div>
                          }
                          { this.state.showUsername &&
                            <div className="row">
                              <Field
                                className="small-12 column"
                                name="username"
                                type="text"
                                validate={[validate.required]}
                                component={renderField}
                                label="Email"/>
                            </div>
                          }

                          <div className="row">
                            <Field
                              className="small-12 column"
                                name="password"
                                type="password"
                                validate={[validate.required, validate.password]}
                                component={renderField}
                                label="Password"/>
                          </div>
                        
                          <div className="row">
                            <div className="small-12 medium-6 column">
                              <Field 
                                  name="country" 
                                  placeholder="Please select country"
                                  validate={ [validate.required] }
                                  component={ SelectComponent } 
                                  onChange={ this.onChangeCountry }
                                  options={ this.state.countries }
                              />
                            </div>
                            {
                              this.state.states.length > 0 ?
                                <div className="small-12 medium-6 column">
                                  <Field 
                                      name="state" 
                                      placeholder="Please select state"
                                      validate={[validate.required]}
                                      component={SelectComponent} 
                                      options={this.state.states}
                                      valueKey="id" 
                                      labelKey="name"
                                  />
                                </div> : <div></div>
                            }

                          </div>
                          
                          <div className="row">
                            <div className="small-12 column">

                              <div className="custom-checkbox">
                                <Field
                                  className="styled-checkbox"
                                  name="hasUnion"
                                  id="union"
                                  value="union"
                                  checked={this.state.hasUnion === 'union'}
                                  onChange={(e) => this.setState({ hasUnion: e.target.value })}
                                  component="input"
                                  validate={[validate.radioval]}
                                  type="radio"
                                />
                                <label htmlFor="union">Union</label>
                              </div>

                              <div className="custom-checkbox">
                                <Field
                                  className="styled-checkbox"
                                  name="hasUnion"
                                  id="non-union"
                                  value="non-union"
                                  checked={this.state.hasUnion === 'non-union'}
                                  onChange={(e) => this.setState({ hasUnion: e.target.value })}
                                  validate={[validate.radioval]}
                                  component="input"
                                  type="radio"
                                />
                                <label htmlFor="non-union">Non Union</label>
                              </div>

                              {this.state.hasUnion === 'union' && (
                                <Field
                                      name="union_id"
                                      type="number"
                                      validate={[validate.required]}
                                      component={renderField}
                                      placeholder="Union ID" />
                              )}
                            </div>
                          </div>

                      </div>
                    }

                  </FormSection>
                }

            </div>
            </div>
          </section>    

          <section className="section">
            <div className="grid-x align-center">
                <div className="small-12 large-1 cell">
                  <ReactLoading style={{margin: '21px', display: this.state.loading ? 'block' : 'none'}} type={type.name} color="#000" />
                </div>
            </div>
            <div className="grid-x align-center">
              <div className="small-12 cell text-center">
                <button className="button primary" 
                  type="submit" 
                  disabled={pristine || submitting}>
                    {submitting ? 'Loading...' : 'Continue' }
                </button>
              </div>
            </div>
          </section>
        </form>
      </div>
    )
  }
}

ProfileForm = reduxForm({
  form: 'artistRegistrationWizard', // <------ same form name
  destroyOnUnmount: false, // <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
  // validate,
  // asyncValidate,
  // asyncBlurFields: ['first_name', 'last_name', 'email']
})(ProfileForm)

const selector = formValueSelector('artistRegistrationWizard')
const mapStateToProps = state => ({
  artistValues: getFormValues('artistRegistrationWizard')(state),
  hasUnion: selector(state, 'artist[hasUnion]'),
  hasCountry: selector(state, 'artist[country]'),
  ageCategory: selector(state, 'artist[ageCategory]'),
  ...state.common,
  ...state.auth,
  ...state.artist
});

const mapDispatchToProps = dispatch => ({
  changeFieldValue: function(field, value) {
      dispatch(change('artistRegistrationWizard', field, value))
  },
  resetForm: () => dispatch(reset('artistRegistrationWizard')),
  onUnload: () =>
    dispatch({ type: 'UNLOAD_PROFILE_FORM' }),
  resetSearch: () => 
    dispatch({ type: 'RESET_SEARCH' }),
  searchArtist: artist => 
    dispatch({ type: 'SEARCH_ARTIST', payload: agent.Artist.search(artist) }),
  artistLogin: (username, password) => 
    dispatch({
      type: 'ARTIST_LOGIN', 
      payload: agent.Artist.login(username, password)
    }),
  partialLogin: (username, password) =>
    dispatch({ 
      type: 'PARTIAL_ARTIST_LOGIN', 
      payload: agent.Artist.login(username, password) }),
  publicLogin: (username, password) =>
    dispatch({ 
      type: 'PUBLIC_ARTIST_LOGIN', 
      payload: agent.Artist.login(username, password) })
});

export default connect(mapStateToProps, mapDispatchToProps)(ProfileForm);


// WEBPACK FOOTER //
// ./src/components/ProfileForm.js